require('./style.less');

var RedactionPropertiesDialog = require('../redactionProperties'),
    $ = require('jquery'),
    _ = require('underscore'),
    fvChannel = require('glRadio').channel('FV');


module.exports = RedactionPropertiesDialog.extend({

    SHOW_FILL_VIEW: 0,

    className: function() {
        return RedactionPropertiesDialog.prototype.className + ' redactionProps-fullPage';
    },

    initialize: function() {

        RedactionPropertiesDialog.prototype.initialize.apply( this, arguments );

        // Non-Responsive Reason Code can be added to available codes, need to check vs original collection
        this.nonResponsiveReasonCodeExistsInSystem =
            fvChannel.request('reasonCodes').containsNonResponsiveReasonCode();

        /* Cache */
        this.NON_RESPONSIVE_REASON_CODE = fvChannel.request('constants').NON_RESPONSIVE_REASON_CODE;

        this.shapeUiModel = this.shapeModel.uiModel;

        // Set the value of the shapeUiModel.isDeniedInFull here, utilizing the fact
        // that selectedCodes where generated on init of the redaction shape view.
        // Seems clearer than doing in the model initialize/parse process.
        // ( Would never apply to new notes -- only those being modified )
        if ( this.selectedCodes.containsNonResponsiveReasonCode() ) {
            this.shapeUiModel.set({ isDeniedInFull: false} );
        }

        // If expanded, disable all controls --
        // only needed on entry; on exit the dialog is destroyed ( so no need to revert );
        // ( Use the note in case enter though a different page and the shape model --
        // the shape model is set in the canvas workflow and may not yet be set ).
        // In the future, if parse shapes with notes, will likely want to set the model values first.
        // TODO - 3.31.21 ( WF has changed since ): pass in so disable to rid dependency of the UI model, esp for test
        this.renderDisabled = this.shapeModel.parentNote.uiModel.get('expanded');

        this.listenTo( this.shapeUiModel, 'change:isDeniedInFull', this.updateToReflectDeniedInFullState );

    },

    serializeData: function() {

        var cxt = RedactionPropertiesDialog.prototype.serializeData.call( this );

        cxt = _.extend( {}, cxt, {
            dontApplyDropdownClass: true,
            nonResponsiveReasonCode: this.NON_RESPONSIVE_REASON_CODE
        });

        return cxt;

    },

    templateHelpers: _.extend( {}, RedactionPropertiesDialog.prototype.templateHelpers, {

        isFullPageRedaction: function() {
            return true;
        }

    }),

    ui: function() {

        return   _.extend( {}, RedactionPropertiesDialog.prototype.ui, {
            fullOrNonResponsiveRadioBtns:       '[name=full-or-non-responsive]',
            cbDeniedInFull:                     '.cb-denied-in-full',
            cbNonResponsive:                    '.cb-non-responsive'
        });

    },
    events: _.extend( {}, RedactionPropertiesDialog.prototype.events, {
        'change @ui.fullOrNonResponsiveRadioBtns': 'fullOrNonResponseRadioButtonChange'
    }),

    // Note: now called from the noteView; not from the shape's dialog open events
    onRender: function() {

        RedactionPropertiesDialog.prototype.onRender.apply( this, arguments );

        this.updateToReflectDeniedInFullState();

        // Handle fringe case if the 'Non Responsive' reason code doesn't exist in the system
        // Don't need to worry about future change of the radio buttons because one will be disabled
        if ( !this.nonResponsiveReasonCodeExistsInSystem ) {
            this._updateViewIfNonResponsiveReasonCodeIsNotInSystem();
        }

        if ( this.renderDisabled ) {
            this.ui.fullOrNonResponsiveRadioBtns.attr( 'disabled', 'disabled' );
        }

        /**
         * For now this will be called superfluously ( but will work since nothing will change from render to destroy ).
         * A better long term solution is to do when active and editing, but save is problematic in current WF.
         * Could also try when this.shapeModel.uiModel.get('isActive') ... but there are better ways to optimize
         */
        this.shapeModel.setSelectedCodeAndFillOnDialogOpen();


    },

    // ( Only called on render )
    // Disable either radio button and set it's title to a message why
    _updateViewIfNonResponsiveReasonCodeIsNotInSystem: function() {

        if ( this.nonResponsiveReasonCodeExistsInSystem )
            return;

        var NON_RESPONSIVE_REASON_CODE_MISSING_WARNING_MSG =
            this.NON_RESPONSIVE_REASON_CODE +
                ' reason code does not exist in database.  Please contact your system administrator.';

        var isDeniedInFull = this.shapeUiModel.get('isDeniedInFull');

        if (isDeniedInFull) {

            // Just Disallow Selection of Non-Responsive -- you can't allow it because the code doesn't exist
            disableNonResponsive.call( this );

        } else {

            if ( this.shapeModel.parentNote.isNew() ) {

                // This could occur if we apply the last code from local store.  We currently aren't doing this --
                // but left here in case we change that.
                disableNonResponsive.call( this );

            } else {

                // When modified, the reasonCode would have to exist on the note --
                // could either disallow a change ( with a prompt the data will be lost ).
                // But for now just don't allow modification .
                // Here the reason code must be selected (by definition); it's put into the 'available' reason codes for the view (see above)
                this.ui.cbDeniedInFull
                    .attr( 'disabled', 'disabled' )
                    .attr( 'title', NON_RESPONSIVE_REASON_CODE_MISSING_WARNING_MSG );
            }

        }

        function disableNonResponsive() {
            this.ui.cbNonResponsive
                .attr( 'disabled', 'disabled' )
                .attr( 'title', NON_RESPONSIVE_REASON_CODE_MISSING_WARNING_MSG );
        }

    },

    updateToReflectDeniedInFullState: function() {

        var isDeniedInFull = this.shapeUiModel.get('isDeniedInFull');

        // Check the approppriate radio button on initial render first ( won't trigger value change event )
        if ( isDeniedInFull ) {

            this.ui.cbDeniedInFull.attr('checked', 'checked');

            // Remove the non-responsive code if it was selected
            if ( this.selectedCodes.containsNonResponsiveReasonCode() ) {
                this.selectedCodes.remove( this.selectedCodes.getNonResponsiveCodeModel(), {
                    sourceNotFromChosen: true
                } );
            }

            // Disable selection of the 'non-responsive' code if
            // if it exists OR does not exist, in the latter case it is added to the available reason codes collection and printed.
            // It's not an item with a model as part of a collection view, just get from the DOM.

            this.reasonCodeRegion.currentView.disableOption( this.NON_RESPONSIVE_REASON_CODE );

            if ( !this.renderDisabled ) {
                this.enableReasonCodesInteraction();
            }


        } else {

            this.ui.cbNonResponsive.attr('checked', 'checked');

            // Re-enable the non-responsive reason code row
            if ( this.nonResponsiveReasonCodeExistsInSystem ) {
                this.reasonCodeRegion.currentView.enableOption( this.NON_RESPONSIVE_REASON_CODE );
            }

            // Remove any selected reason codes and apply the non-responsive reason code.
            // For now, do so without a prompt.
            // Add the Non-Responsive Code ( this will be disabled if it doesn't exist ).
            this.selectedCodes.remove( this.selectedCodes.models, { silent: true} );
            this.selectedCodes.add( this.availableReasonCodes.getNonResponsiveCodeModel(), {
                sourceNotFromChosen: true
            } );

            this.disableReasonCodesInteraction();

        }

    },

    fullOrNonResponseRadioButtonChange: function(e) {

        var $target = $(e.target),
            isDeniedInFull = $target.val() === 'DENIED_IN_FULL'; // (hard coded now ... could get from reason code collection )

        this.shapeUiModel.set({ isDeniedInFull: isDeniedInFull });

    },


    /* Disallow adding 'Non-Responsive' Code on select all when denied in full */
    _getReasonCodeModelsForSelectAll: function() {

        if ( this.shapeUiModel.get('isDeniedInFull') ) {

            /* could cache */
            return this.availableReasonCodes.reject ( function(rc) {
                return rc.get('code') === this.NON_RESPONSIVE_REASON_CODE;
            }, this);

        } else {

            return this.availableReasonCodes.models;
        }

    },

    onBeforeDestroy: function() {

        // Again, would rather called on save but that's a bit problematic and would need more outlining.
        this.shapeModel.updateLocalStoragePostDialogClose();

        this.stopListening( this.shapeUiModel );



    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/dialog/fullPageRedaction/view.js
 ** module id = 314
 ** module chunks = 0
 **/